import React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Typography,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import { useAppSelector } from '../../../../hooks';
import { ISubTopic } from '../../../../store/SubTopicSlice';
import { getTopicState } from '../../../../store/TopicSlice';

interface FrequentlyAskedQuestionSectionProps {
  subTopic: ISubTopic;
}

const FrequentlyAskedQuestionSection: React.FC<FrequentlyAskedQuestionSectionProps> = ({
  subTopic,
}) => {
  // Store
  const topicState = useAppSelector(getTopicState);

  const { topicsWithSubTopics } = topicState;
  const faqList = subTopic.FAQs || [];

  // State
  const [expanded, setExpanded] = React.useState<string | false>(false);

  const handleChange = (panel: string) => (
    event: React.SyntheticEvent,
    newExpanded: boolean
  ) => {
    setExpanded(newExpanded ? panel : false);
  };

  const isTopicPlanner = (subTopicData) =>
    subTopicData.name === 'Topic Planner' ||
    subTopicData.name === 'Topic Overview';

  const isFAQEnabled = () => {
    const selectedTopic = topicsWithSubTopics.find(
      (topicItem) => topicItem._id === subTopic.topic._id
    );

    if (selectedTopic && selectedTopic.subTopics.length) {
      const checkTopicPlannerAvailability = selectedTopic.subTopics.find(
        (subTopicItem) => isTopicPlanner(subTopicItem)
      );

      if (checkTopicPlannerAvailability) {
        if (isTopicPlanner(subTopic)) {
          return true;
        }
      } else {
        const selectedSubTopic = selectedTopic.subTopics.find(
          (subTopicItem) => subTopicItem.resources?.length
        );
        if (selectedSubTopic && selectedSubTopic._id === subTopic._id) {
          return true;
        }
      }
    }

    return false;
  };

  return isFAQEnabled() ? (
    <section style={{ marginTop: '70px' }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} lg={6} textAlign="center">
          <img
            src={`${process.env.PUBLIC_URL}/images/faq-image.png`}
            alt="FAQ"
            style={{ maxWidth: '100%' }}
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          {faqList.map((item, index) => {
            const itemId = `panel-${index + 1}`;
            const _styles: React.CSSProperties = {
              margin: 0,
              borderWidth: 1,
              borderStyle: 'solid',
              borderColor: '#E2E8F0',
              borderTop: 'none',
            };

            if (index === 0) {
              delete _styles.borderTop;
              _styles.borderTopLeftRadius = '20px';
              _styles.borderTopRightRadius = '20px';
            }

            if (index === faqList.length - 1) {
              delete _styles.borderBottom;
              _styles.borderBottomLeftRadius = '20px';
              _styles.borderBottomRightRadius = '20px';
            }

            return (
              <React.Fragment key={`faq-item-${index + 1}`}>
                <Accordion
                  elevation={0}
                  expanded={expanded === itemId}
                  style={_styles}
                  onChange={handleChange(itemId)}
                  sx={{
                    '&:before': {
                      backgroundColor: 'transparent !important',
                    },
                  }}
                >
                  <AccordionSummary
                    expandIcon={<KeyboardArrowDownIcon />}
                    style={{ padding: '15px', border: 'none' }}
                  >
                    <Typography fontWeight={500} color="#334155">
                      {item.question}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails style={{ border: 'none' }}>
                    <Typography variant="subtitle2">{item.answer}</Typography>
                  </AccordionDetails>
                </Accordion>
              </React.Fragment>
            );
          })}
        </Grid>
      </Grid>
    </section>
  ) : null;
};

export default FrequentlyAskedQuestionSection;
